import { call, put, takeLatest } from 'redux-saga/effects';
import { ExploreActionTypes } from './exploreTypes';
import { exploreApiResponseSuccess, exploreApiResponseError } from './exploreActions';
import { exploreMessageApi, exploreSummariseApi } from '../api/distillNode';

function* sendMessageSaga(action: any): any {
  try {
    const { message, history, sessionId } = action.payload;
    const response = yield call(exploreMessageApi, { sessionId, message, history });
    const data = response.data ?? response;
    yield put(
      exploreApiResponseSuccess(ExploreActionTypes.SEND_MESSAGE, {
        ...data,
        userMessage: message,
      }),
    );
  } catch (error: any) {
    yield put(
      exploreApiResponseError(
        ExploreActionTypes.SEND_MESSAGE,
        error?.response?.data?.error || error?.message || 'Message failed',
      ),
    );
  }
}

function* summariseSaga(action: any): any {
  try {
    const { sessionId, insightText, history } = action.payload;
    const response = yield call(exploreSummariseApi, { sessionId, insightText, history });
    const data = response.data ?? response;
    yield put(exploreApiResponseSuccess(ExploreActionTypes.SUMMARISE, data));
  } catch (error: any) {
    yield put(
      exploreApiResponseError(
        ExploreActionTypes.SUMMARISE,
        error?.response?.data?.error || error?.message || 'Summarise failed',
      ),
    );
  }
}

export default function* exploreSaga() {
  yield takeLatest(ExploreActionTypes.SEND_MESSAGE, sendMessageSaga);
  yield takeLatest(ExploreActionTypes.SUMMARISE, summariseSaga);
}
